

function About() {
    return(
       <main className="about">
        <img src="images/me.jpg" />
        <p id="about-info">
            i'am Yousif, a full stack web developer, web designer, native apps developer, graphic designer, and web pentration tester. i specialize in front-end web development.
        </p>
        <h2>Common Skills:</h2>
        <div>
          
            <div><h2>HTML</h2></div>
            <div><h2>CSS</h2></div>
            <div><h2>JavaScript</h2></div>
            <div><h2>React js</h2></div>
            <div><h2>Node js</h2></div>
            <div><h2>Sass</h2></div>
            <div><h2>Git</h2></div>

        </div>
       </main>
    )
}
export default About;
